import { Overlay, createOverlay } from '@vfde-brix/ws10/overlay';
import { HtmlId, OverlayView } from '../enum';
import { createComponentById, toggleElementsVisibilityById, toggleElementVisibilityById } from '@vfde-brix/ws10/core';
import { setOverlayVisibility } from '../container/App/action';

export const mountOverlay = (id: HtmlId, showOverlay: typeof setOverlayVisibility) =>
    createComponentById(createOverlay, id, {
        business: {
            onClose: () => showOverlay(false),
        },
        optPaddingLayout: true,
        optAnimation: 'slide',
    });

export const showOverlay = (comp: Overlay | null, isOpen: boolean) =>
    isOpen ? comp?.open() : comp?.close();

export const updateOverlayView = (visibleView: OverlayView) => {
    toggleElementsVisibilityById(Object.values(OverlayView), false);
    toggleElementVisibilityById(visibleView, true);
};
